module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_feeling01_gray-c91f535d3d599ec8423215b620f43128.svg";